module.exports = __webpack_public_path__ + "img/icloud.54edde26.png";